import script from "./IConcert.vue?vue&type=script&setup=true&lang=js"
export * from "./IConcert.vue?vue&type=script&setup=true&lang=js"

import "./IConcert.vue?vue&type=style&index=0&id=0338a546&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0338a546"]])

export default __exports__